module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "流量趋势",
      "description": "提供网站实时的流量数据，通过流量的趋势变化，来分析出网站访客的访问规律、网站发展状况等",
      "pos": "right",
      "date": _vm.timeSpan
    }
  }), _c('timeSpan', {
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('TopStatis', {
    attrs: {
      "data": _vm.topStatisData
    }
  }), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }, [_c('IndiceCompare', {
    attrs: {
      "indicesMenu": _vm.indicesMenu,
      "indice": _vm.baseIndice,
      "compIndice": _vm.compareIndice
    },
    on: {
      "indiceChange": _vm.indiceChange
    }
  })], 1), _c('LineChart', {
    attrs: {
      "yAxis": _vm.yAxis,
      "legend": _vm.flowChartLegend,
      "xAxis": _vm.flowChartXAxis,
      "series": _vm.flowChartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": "流量趋势报表"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fluxTableList.length),
      expression: "fluxTableList.length"
    }],
    staticClass: "download-btn"
  }, [_c('DownloadBtn', {
    attrs: {
      "reportApi": "/api/report/flow",
      "pagetitle": "流量趋势报表",
      "params": _vm.downloadParams
    }
  })], 1), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices,
      "hasSystemIndice": _vm.hasSystemIndice
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('ComplexTable', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.currentPageList,
      "sum": {}
    }
  }), _c('v-pagination', {
    attrs: {
      "total": _vm.fluxTableList.length,
      "pn": _vm.pageNum,
      "ps": "10"
    },
    on: {
      "updatepage": _vm.onPageChange
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d7e3d57a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7e3d57a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/flux.vue
// module id = 802
// module chunks = 0